<template>
    <el-dialog
      custom-class="user_info_modal"
      v-model="modelMainVisible"
      @open="openModal"
      @close="closeModal"
      :destroy-on-close="true"
      :append-to-body="true"
    >
     
  
      <el-carousel
        :class="user.files && user.files.length ? 'with_arrow' : ''"
        trigger="click"
        :autoplay="false"
      >
      <el-carousel-item v-if="user.image || user.files.length">
        <img class="user_image" :src="user.image" v-if="user.image" />
        <el-empty class="user_image" v-else></el-empty>
      </el-carousel-item>
        <el-carousel-item
          :class="$filters.getFileType(file)"
          v-for="(file) in user.files"
          :key="file.src"
        >
          <img
            class="user_image"
            :src="file.url"
            alt=""
            v-if="$filters.getFileType(file) == 'image'"
          />
         
        </el-carousel-item>
      </el-carousel>
      <img v-if="!user.image" class="user_image" :src="require(`@/assets/img/intro/background/back.svg`)" />
      <div class="user_image_gradient"></div>
      <div class=" user_main_info-padding">
        <div class=" user_main_info">
          <div class="image_text_comp">
        
               <div class="text_wrapper text_wrapper-flex" >

              <div class="item-flex">
                <div class="main_text">{{ user.name }} (Agency)</div>
                <div class="additional_text">
                  <i class="el-icon-message"></i>{{ user.email }}
                </div>
                <div class="additional_text">
                  <i class="el-icon-phone"></i>{{ user.phone }}
                </div>
                <div
                  class="additional_text"
                  v-if="agencyAddressText"
                >
                  <i class="el-icon-location-outline"></i>{{ agencyAddressText }}
                </div>
              </div>

              <div class="item-flex" v-if="user.locum">
                <div class="main_text"> <i class="el-icon-user"></i> Locum</div>
                <div class="additional_text">
                  Name : {{ user.locum?.firstName }} {{ user.locum?.lastName }}
                </div>
                <div class="additional_text">
                  Rate: ${{ user.locum?.rate }}
                </div>
              </div>


            </div>
          </div>
        </div>
  
  
      </div>
      <div class="el-dialog__footer">
        <el-button
          class="submit_page"
          v-if="user.role == 'pharmacy'"
          type="black"
          @click="goToMap()"
        >
          <span class="locumate_icons locumate_icon-map"></span><span>Map</span>
        </el-button>
        <el-button class="submit_page" type="blue" @click="goToChat()">
          <span class="locumate_icons locumate_icon-message"></span
          ><span>Chat</span>
        </el-button>
  
        <el-button v-if="params && params.showRemovePrefferedStore" class="submit_page" type="blue" @click="showRemovePharmacyConfimation()">
          <span class="locumate_icons locumate_icon-remove_square"></span
          ><span>Remove </span>
        </el-button>
  
  
      </div>
    </el-dialog>
  </template>
  
  <script>
  
  import {
    ref,
    // reactive,
    onMounted,
    inject,
    computed,
    nextTick,
  
    // nextTick
  } from "vue";
  import { useStore } from "vuex";
  import {
    useRouter,
    // useRoute
  } from "vue-router";
  
//   import store from "@/store/store";
  
  export default {
    components: {
     
    },
    props: {
      modalName: {
        type: String,
      },
      options: {
        type: Object,
      },
    },
    setup(props) {
      console.log("🚀 ~ file: Agency.vue:127 ~ setup ~ props:", props)
      const $store = useStore();
      const $router = useRouter();
      const $mitt = inject("$mitt");
      // const pusher = inject(['pusher']);
    //   const $modals = inject("$modals");
      // const loading = ref(true);
      const modelMainVisible = ref(false);
  
      const userData = $store.getters.GET_USER_DATA;
      const userRole = userData.role;
      const user = computed(() => {
        return props.options.user;
      });

      const agencyAddressText = computed(() => {
        const address = user.value?.address;
        if (!address) return "";
        return (
          address.fullAddress ||
          address.full_address ||
          [
            address.shopNumber || address.shop_number
              ? `Unit ${address.shopNumber || address.shop_number}`
              : null,
            address.street,
            address.suburb,
            address.state,
            address.postcode,
            address.country,
          ]
            .filter(Boolean)
            .join(", ")
        );
      });
  
      const environment = ref({});
  
      const distance = ref(null);
  
      const bottomDropUp = ref(false);
  
      $mitt.on(props.modalName, (options) => {
        modelMainVisible.value = options.show;
      });
  
  
  
  
  
      onMounted(() => {});
  
      const carouselHeight = ref(null);
  
      const setCarouselHeight = () => {
        setTimeout(() => {
          nextTick(console.log($(".el-carousel").width()));
          $(".el-carousel").css(
            "--carousel-height",
            `${$(".el-dialog__body").width()}px`
          );
        }, 500);
  
        // $('.el-carousel').css('--carousel-height', `${$('.el-carousel')[0].innerWidth}px`);
      };
  
      const videoPlayer = ref([]);
    
  
      let videosSrc = [];
  
      const openModal = () => {
        window.addEventListener("resize", setCarouselHeight);
        setCarouselHeight();
  
      
  
      };
      const closeModal = () => {
        modelMainVisible.value = false;
      };
  
      const sendReport = (user) => {
        bottomDropUp.value = false;
        $store.dispatch("setReportData", {
          userData: user,
        });
        $router.push({
          name: "report",
          params: {
            userId: user.id,
          },
        });
      };
  
      const goToMap = () => {
        closeModal();
  
        // ${encodeURI('https://www.google.com/maps/dir/?api=1&origin=Space+Needle+Seattle+WA&destination=Pike+Place+Market+Seattle+WA&travelmode=transit')}
        // https://www.google.com/maps/search/?api=1&query=
        // window.open(`https://www.google.com/maps/place/${user.value.address.lat},${user.value.address.lng}`)
  
        if (
          navigator.platform.indexOf("iPhone") != -1 ||
          navigator.platform.indexOf("iPod") != -1 ||
          navigator.platform.indexOf("MacIntel") != -1 ||
          navigator.platform.indexOf("iPad") != -1
        ) {
          const originCord = userData.address.lat + "," + userData.address.lng;
  
          const destinationCord =
            user.value.address.lat + "," + user.value.address.lng;
  
          const origin = userData.address ? `saddr=${originCord}&` : "";
  
          const destination = user.value.address
            ? `daddr=${destinationCord}&`
            : "";
  
          window.open(
            `http://maps.apple.com/?${origin}${destination}dirflg=d&t=m`
          );
        }
  
        // window.open(`maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic${origin}${destination}${zoom}`);
        // window.open(`http://maps.apple.com/?saddr=${userData.address.text}&daddr=${user.value.address.text}&dirflg=d&t=m`);
        else {
          const zoom = `&zoom=16`;
          const origin = userData.address.lat
            ? `&origin=${userData.address.lat},${userData.address.lng}`
            : "";
          const destination = user.value.address.lat
            ? `&destination=${user.value.address.lat},${user.value.address.lng}`
            : "";
          window.open(
            `https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic${origin}${destination}${zoom}`
          );
        }
      };
      const goToChat = () => {
        closeModal();
        const chatId =
          userRole == "pharmacy"
            ? userData.id + "." + user.value.userId
            : user.value.userId + "." + userData.id;
        // pusher.pusherChatSubscribe(chatId)
        $router.push({
          name: "chat_message",
          params: {
            chatId: chatId,
            // opponentId: user.value.id
          },
        });
      };
  
      return {
        openModal,
        closeModal,
        // loading,
        modelMainVisible,
        user,
        userRole,
        agencyAddressText,
        distance,
        bottomDropUp,
        environment,
        goToMap,
        goToChat,
        sendReport,
        carouselHeight,
        videoPlayer,
        videosSrc,
      };
    },
  };
  </script>
  